import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { useFormContext } from 'react-hook-form';

import { serviceTypeOptions } from 'src/features/add-trip/ServiceDetails/serviceTypeOptions';

import type { SchemeMetaFormValues } from './metaDefaultValues';

export function ScopeCheckAlert() {
  const { watch } = useFormContext<SchemeMetaFormValues>();

  const rawSelected = watch('service_types');
  const mileageLower = watch('mileage_range_lower_miles');
  const mileageUpper = watch('mileage_range_upper_miles');

  const knownValues = new Set(serviceTypeOptions.map((o) => o.value));
  const selectedCount = new Set(
    (rawSelected ?? []).filter((t) => knownValues.has(t))
  ).size;
  const totalCount = serviceTypeOptions.length;

  const hasServiceTypeRestriction =
    selectedCount > 0 && selectedCount < totalCount;

  const hasMileageRestriction = !!mileageLower || !!mileageUpper;

  if (!hasServiceTypeRestriction && !hasMileageRestriction) return null;

  const mileageScopeText = (() => {
    if (mileageLower && mileageUpper) {
      return `${mileageLower}-${mileageUpper} miles`;
    }

    if (mileageLower) {
      return `${mileageLower}+ miles`;
    }

    if (mileageUpper) {
      return `under ${mileageUpper} miles`;
    }
    return null;
  })();

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="flex gap-3 rounded-md border border-yellow-400 bg-yellow-50 p-4"
    >
      <ExclamationTriangleIcon
        aria-hidden="true"
        className="h-5 w-5 flex-shrink-0 text-yellow-400"
      />
      <div className="space-y-1 text-sm text-yellow-800">
        <p>
          <strong>Scope check:</strong> This pricing model is restricted to:
        </p>
        <ul className="ml-4 list-disc space-y-0.5">
          {hasServiceTypeRestriction && (
            <li>
              <strong>
                {selectedCount} of {totalCount}
              </strong>{' '}
              service types
            </li>
          )}
          {mileageScopeText && (
            <li>
              Trips <strong>{mileageScopeText}</strong>
            </li>
          )}
        </ul>
        <p>Trips outside this scope won't receive a price from this model.</p>
      </div>
    </div>
  );
}
